import { Svg } from '../../utils/IconBase';
import { IconProps } from '../../utils/icon';

const IconFileDraftLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.308 21.5c-.505 0-.933-.175-1.283-.525a1.745 1.745 0 0 1-.525-1.283V4.308c0-.505.175-.933.525-1.283.35-.35.778-.525 1.283-.525h7.194c.241 0 .473.047.695.14.223.094.416.223.58.387l4.196 4.196c.164.164.293.357.387.58.093.222.14.454.14.695v11.194c0 .505-.175.933-.525 1.283-.35.35-.778.525-1.283.525H6.308ZM13.5 7.596V4H6.308a.294.294 0 0 0-.212.096.294.294 0 0 0-.096.212v15.384c0 .077.032.148.096.212a.294.294 0 0 0 .212.096h11.384a.294.294 0 0 0 .212-.096.294.294 0 0 0 .096-.212V8.5h-3.596a.875.875 0 0 1-.645-.259.875.875 0 0 1-.259-.645Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconFileDraftLine;
